<template>
  <div
    class="td-content"
    style="justify-content: center;"
  >
    <div
      class="external-btn"
      v-for="(button, i) in header.buttons"
      :key="i"
      @click.stop="onClickButton(button.eventName)"
    >
      <div
        v-html="button.content"
        v-tooltip="getTooltip(button)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "wt-buttons-row",
  props: {
    data: {
      type: Object,
    },
    header: {
      type: Object,
    },
    position: {
      type: Number,
    },
    storeName: {
      type: String,
    },
  },
  methods: {
    getTooltip(button) {
      const { tooltip } = button;

      if (typeof tooltip === "function") {
        return {
          content: tooltip(this.data),
          container: ".external-btn",
        };
      } else if (tooltip) {
        return {
          content: tooltip,
          container: ".external-btn",
        };
      }

      return null;
    },
    onClickButton(eventName) {
      this.$store.dispatch(`${this.storeName}/table/emitEvent`, {
        name: eventName,
        payload: {
          data: this.data,
          position: this.position,
        },
      });
    },
  },
};
</script>